/** Receives an array, and index of elements we want to swap
@array { array } - array in which we want to swap elements
@indexA { number } - index of elements to be swapped
@indexB { number } - index of elements to be swapped
@return { array }
*/
export const swapArrayElements = (array, indexA, indexB) => {
	if (array.length === 1) return array
	array.splice(indexB, 1, array.splice(indexA, 1, array[indexB])[0])
	return array
}

/** Receives an array, and index of element we want to move and the move position
@array { array } - array in which we want to swap elements
@indexA { number } - index of elements to be moved
@indexB { number } - position where we will be inserting our element
@return { array }
*/
export const moveElementInArray = (array, elementPosition, newPosition) => {
	if (array.length === 1) return array
	array.splice(newPosition, 0, array.splice(elementPosition, 1)[0])
	return array
}
